class DestinationCostModel {
  constructor() {
    const data = JSON.parse(localStorage.getItem("destinationCostData")) || {};


    this._destinationName = data.destinationName || "";
    this._destinationKM = data.destinationKM || 0;
    this._adjustDistance = data.adjustDistance || 0;
    this._additionalCharge = data.additionalCharge || 0;
    this._waitMinute = data.waitMinute || 0;
    this._baseAmount = data.baseAmount || 0;
    this._waitingCharge = data.waitingCharge || 0;
    this._surCharge = data.surCharge || 0;
    this._convenienceFee = data.convenienceFee || 0;
    this._CGST = data.CGST || 0;
    this._SGST = data.SGST || 0;
    this._highRateCharge = data.highRateCharge || 0;
    this._tollCharge = data.tollCharge || 0;
    this._totalAmount = data.totalAmount || 0;
    this._peakTimeCharge = data.peakTimeCharge || 0;
    this._fareAmount = data.fareAmount || 0;
    this._isMinimumKMApplied = data.isMinimumKMApplied || false;
    this._actualCalculatedDistance = data.actualCalculatedDistance || 0;

  }

  get destinationName() {
    return this._destinationName;
  }

  set destinationName(value) {
    this._destinationName = value;
    this._save();
  }

  get destinationKM() {
    return this._destinationKM;
  }

  set destinationKM(value) {
    this._destinationKM = value;
    this._save();
  }

  get adjustDistance() {
    return this._adjustDistance;
  }

  set adjustDistance(value) {
    this._adjustDistance = value;
    this._save();
  }

  get additionalCharge() {
    return this._additionalCharge;
  }

  set additionalCharge(value) {
    this._additionalCharge = value;
    this._save();
  }

  get waitMinute() {
    return this._waitMinute;
  }

  set waitMinute(value) {
    this._waitMinute = value;
    this._save();
  }

  get baseAmount() {
    return this._baseAmount;
  }

  set baseAmount(value) {
    this._baseAmount = value;
    this._save();
  }

  get waitingCharge() {
    return this._waitingCharge;
  }

  set waitingCharge(value) {
    this._waitingCharge = value;
    this._save();
  }

  get surCharge() {
    return this._surCharge;
  }

  set surCharge(value) {
    this._surCharge = value;
    this._save();
  }

  get convenienceFee() {
    return this._convenienceFee;
  }

  set convenienceFee(value) {
    this._convenienceFee = value;
    this._save();
  }

  get CGST() {
    return this._CGST;
  }

  set CGST(value) {
    this._CGST = value;
    this._save();
  }

  get SGST() {
    return this._SGST;
  }

  set SGST(value) {
    this._SGST = value;
    this._save();
  }

  get highRateCharge() {
    return this._highRateCharge;
  }

  set highRateCharge(value) {
    this._highRateCharge = value;
    this._save();
  }

  get tollCharge() {
    return this._tollCharge;
  }

  set tollCharge(value) {
    this._tollCharge = value;
    this._save();
  }

  get totalAmount() {
    return this._totalAmount;
  }

  set totalAmount(value) {
    this._totalAmount = value;
    this._save();
  }


  get peakTimeCharge() {
    return this._peakTimeCharge;
  }

  set peakTimeCharge(value) {
    this._peakTimeCharge = value;
    this._save();
  }

  get fareAmount() {
    return this._fareAmount;
  }

  set fareAmount(value) {
    this._fareAmount = value;
    this._save();
  }

  get isMinimumKMApplied() {
    return this._isMinimumKMApplied;
  }

  set isMinimumKMApplied(value) {
    this._isMinimumKMApplied = value;
    this._save();
  }

  get actualCalculatedDistance() {
    return this._actualCalculatedDistance;
  }

  set actualCalculatedDistance(value) {
    this._actualCalculatedDistance = value;
    this._save();
  }

  _save() {
    localStorage.setItem("destinationCostData", JSON.stringify({
      destinationName: this._destinationName,
      destinationKM: this._destinationKM,
      adjustDistance: this._adjustDistance,
      additionalCharge: this._additionalCharge,
      waitMinute: this._waitMinute,
      baseAmount: this._baseAmount,
      waitingCharge: this._waitingCharge,
      surCharge: this._surCharge,
      convenienceFee: this._convenienceFee,
      CGST: this._CGST,
      SGST: this._SGST,
      highRateCharge: this._highRateCharge,
      tollCharge: this._tollCharge,
      totalAmount: this._totalAmount,
      peakTimeCharge: this._peakTimeCharge,
      fareAmount: this._fareAmount,
      isMinimumKMApplied: this._isMinimumKMApplied,
      actualCalculatedDistance: this._actualCalculatedDistance

    }));
  }
}

export default new DestinationCostModel();